module.exports = __webpack_public_path__ + "img/enterprise-main16.83b7c795.png";